import { render, staticRenderFns } from "./BellIcon.vue?vue&type=template&id=b09105be"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b09105be')) {
      api.createRecord('b09105be', component.options)
    } else {
      api.reload('b09105be', component.options)
    }
    module.hot.accept("./BellIcon.vue?vue&type=template&id=b09105be", function () {
      api.rerender('b09105be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/BellIcon.vue"
export default component.exports